export enum EstClearanceTime {
  NOT_SELECTED = "",
  TIME_90_TO_2_HOURS = "90 minutes to 2 hours",
  TIME_2_TO_4_HOURS = "2 to 4 hours",
  TIME_4_TO_6_HOURS = "4 to 6 hours",
  TIME_6_TO_8_HOURS = "6 to 8 hours",
  TIME_MORE_THAN_8_HOURS = "More than 8 hours",
  OTHER = "Other",
}
